import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import { generatePath } from 'react-router-dom';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Text18 } from '@sorare/core/src/atoms/typography';
import { FOOTBALL_PLAY_RIVALS_DRAFT_SLUG } from '@sorare/core/src/constants/__generated__/routes';

import { BriefGame } from 'components/so5/BriefGame';

import { PlayerUpcomingGames_game } from './__generated__/index.graphql';

type Props = {
  games: (PlayerUpcomingGames_game | null)[];
  withRivalsLinks?: boolean;
};
const PlayerUpcomingGames = ({ games, withRivalsLinks }: Props) => {
  if (!games.length) {
    return null;
  }

  return (
    <Vertical>
      <Text18 bold>
        <FormattedMessage
          id="ComposeTeam.PlayerDetailsDialog.PlayerUpcomingGames.Title"
          defaultMessage="Upcoming games"
        />
      </Text18>
      <Vertical gap={2}>
        {games.map(game => {
          if (!game) {
            return null;
          }

          if (!withRivalsLinks) {
            return !!game && <BriefGame key={game.id} game={game} />;
          }

          const { rivalsGame } = game;
          const onClick = rivalsGame
            ? () => {
                window.open(
                  generatePath(FOOTBALL_PLAY_RIVALS_DRAFT_SLUG, {
                    slug: rivalsGame.slug,
                  }),
                  '_blank'
                );
              }
            : undefined;

          return (
            !!game && <BriefGame key={game.id} game={game} onClick={onClick} />
          );
        })}
      </Vertical>
    </Vertical>
  );
};

PlayerUpcomingGames.fragments = {
  game: gql`
    fragment PlayerUpcomingGames_game on Game {
      id
      date
      rivalsGame {
        slug
      }
      ...BriefGame_anyGameInterface
    }
    ${BriefGame.fragments.anyGameInterface}
  ` as TypedDocumentNode<PlayerUpcomingGames_game>,
};

export default PlayerUpcomingGames;
